import { createAction } from '@reduxjs/toolkit';

export const TOGGLE_THEME = createAction('TOGGLE_THEME');
export const TOGGLE_THEME_DIRECTION = createAction('TOGGLE_THEME_DIRECTION');
export const SET_SELECTED_THEME = createAction('SET_SELECTED_THEME');
